import React from 'react';
import styles from './Table.module.scss';

const TableBody = (props) => <tbody className={styles.tableBody}>{props.children}</tbody>;

export default TableBody;
